import { useState } from 'react';
import { AccountStatusCounts } from 'vopay';
import { api } from '@/services/api.config';

/**
 * Per-status account counts across a partner's book. `bearer` scopes the call to another partner
 * account's token, which the partner page's Accounts tab uses.
 */
export default function useFetchPartnerAccountStatusSummary({ bearer }: { bearer?: string } = {}) {
  const [fetchingStatusSummary, setFetchingStatusSummary] = useState(false);
  const [numTotalAccounts, setNumTotalAccounts] = useState(0);
  // Partial only until the response lands; every status is present once it has.
  const [statusCounts, setStatusCounts] = useState<Partial<AccountStatusCounts>>({});

  async function fetchPartnerAccountStatusSummary() {
    try {
      setFetchingStatusSummary(true);
      const res = await api.fetchPartnerAccountStatusSummary(undefined, bearer);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setNumTotalAccounts(res.TotalAccounts);
      setStatusCounts(res.StatusCounts);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetchingStatusSummary(false);
    }
  }

  return { fetchingStatusSummary, numTotalAccounts, statusCounts, fetchPartnerAccountStatusSummary };
}
